enum AllocationsModalWindowTitle {
  TimeOffFormTitle = 'Time Off',
  BookingFormTitle = 'Booking'
}

export default AllocationsModalWindowTitle;
